<action-bar>
  <action-button
    [className]="'action-primary'"
    [iconClass]="'fa fa-plus'"
    (actionClick)="gotoNewSet()"
    >
    Add Competency Set
  </action-button>
</action-bar>

<div class="row">
  <div class="col table-title">
    <h1>Competencies</h1>
  </div>
  <div class="col">
    <div class="pull-right">
      Quick Search:
      <input
        type="text"
        [(ngModel)]="inputQuickSearch"
        id="filter-text-box"
        placeholder="Type here..."
        (keyup)="onFilterTextBoxChanged()"
        />
        <button (click)="resetFilters()">Reset Filters</button>
      </div>
    </div>
  </div>

  <div class="row" id="GridWithH1">
    <div class="col" style="width: 100%; height: 100%;">
      <ag-grid-angular
        style="height: 100vh"
        [gridOptions]="gridOptions"
        [rowData]="competencySetsRows"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    </div>
  </div>

  <div class="gridFooter">
    <span>Rows per page:</span>
    <select
      style="display: inline;"
      [ngModel]="selectedPaginationOption"
      (change)="onChangePaginationOption($event.target.value)"
      >
      @for (option of paginationOptions; track option) {
        <option [value]="option.id">
          {{ option.name }}
        </option>
      }
    </select>
  </div>
